import React, { createContext, useContext } from 'react';
import useCheckInitialSetup from './useCheckInitialSetup';

const InitialSetupCheckContext = createContext(null);

export function InitialSetupCheckProvider({ children }) {
    const value = useCheckInitialSetup();

    return (
        <InitialSetupCheckContext.Provider value={value}>
            {children}
        </InitialSetupCheckContext.Provider>
    );
}

export function useInitialSetupCheck() {
    const context = useContext(InitialSetupCheckContext);

    if (!context) {
        throw new Error('useInitialSetupCheck must be used within InitialSetupCheckProvider');
    }

    return context;
}
